export var detailUtil = {
    toggle: function (_a) {
        var handler = _a.handler, content = _a.content;
        var isOpen = handler.classList.contains('open');
        var height = [];
        if (isOpen) {
            handler.classList.remove('open');
            height = ["".concat(content.offsetHeight, "px"), '0'];
        }
        else {
            content.classList.add('open');
            handler.classList.add('open');
            height = ['0px', "".concat(content.offsetHeight, "px")];
        }
        var animation = content.animate({ height: height }, {
            duration: 300,
            easing: 'linear',
        });
        animation.onfinish = function () { return content.classList.toggle('open', !isOpen); };
    },
};
